import React from "react";
import { useSelector } from "react-redux";
import Error from "../../../../components/Error/index";
import Spinner from "../../../../components/presentationals/Spinner";
import { CustomSalesCard } from "../../../../components/customSalesCard/index";
import { roundToTwo } from "../../../../utils/common/index";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "10px",
    height: "20px",
    width: "20px",
    display: "flex",
    // justifyContent: "center",
    alignItems: "center",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));

const SimActivationView = ({
  csvName,
  isCsvActive,
  csvHandlerJiophone,
  fetchSimActivationCsvData,
  section,
  moduleName,
}) => {
  const { simActivationObj, simActivationJiophoneObj, actCsvLoading } =
    useSelector((state) => state.activationSalesReducer);

  let {
    simActivationData: { actualCount, targetCount, avgPerDayCount },
  } = simActivationObj;

  const jiophoneRaw = simActivationJiophoneObj?.simActivationData;
  const jiophoneRows = Array.isArray(jiophoneRaw) ? jiophoneRaw : [];

  const activationTypeLabel = (obj) =>
    obj?.activationType?.trim()
      ? String(obj.activationType).trim()
      : "—";

  return (
    <>
      <div className="d-block d-sm-none col-12">
        <div
          id="carousel-div"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carousel-div"
              data-bs-slide-to="0"
              className="active"
            ></button>
            <button
              type="button"
              data-bs-target="#carousel-div"
              data-bs-slide-to="1"
            ></button>
            <button
              type="button"
              data-bs-target="#carousel-div"
              data-bs-slide-to="2"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              {simActivationObj.loading ? (
                <Spinner />
              ) : Object.keys(simActivationObj.simActivationData).length ? (
                <CustomSalesCard
                  achieved={actualCount}
                  target={roundToTwo(targetCount)}
                  tileName="Ach/Target"
                  csvDownload={
                    isCsvActive === "Y" ? fetchSimActivationCsvData : ""
                  }
                  csvName="simAct"
                  image="Image4"
                  gradient="3"
                  loading={actCsvLoading}
                  dashboardName={moduleName}
                  viewName={section}
                />
              ) : (
                <Error error={simActivationObj.error} />
              )}
            </div>

            <div className="carousel-item">
              {simActivationObj.loading ? (
                <Spinner />
              ) : Object.keys(simActivationObj.simActivationData).length ? (
                <CustomSalesCard
                  value={roundToTwo(avgPerDayCount)}
                  tileName="Avg Per Day (Last 7 days)"
                  image="Image5"
                  showGraph={true}
                  gradient="4"
                  dashboardName={moduleName}
                  viewName={section}
                />
              ) : (
                <Error error={simActivationObj.error} />
              )}
            </div>
            <div className="carousel-item">
              {simActivationJiophoneObj?.loading ? (
                <Spinner />
              ) : simActivationJiophoneObj?.error ? (
                <Error error={simActivationJiophoneObj.error} />
              ) : (
                <div
                  className="grad3 staticHeightSales whiteoverlaycir wow fadeInUp p-1 pt-0"
                  style={{ overflowY: "auto" }}
                >
                  <table className="table table-sm text-white text-center table-borderless mb-0">
                    <thead>
                      <tr>
                        <th
                          style={{ background: "#fdb082" }}
                          scope="col"
                        >
                          Activation Type
                        </th>
                        <th
                          style={{ background: "#fdb082" }}
                          scope="col"
                        >
                          Activation Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {jiophoneRows.length === 0 ? (
                        <tr>
                          <td
                            colSpan={2}
                            className="text-white text-center small py-2"
                            style={{ opacity: 0.9 }}
                          >
                            No activation type breakdown for this selection.
                          </td>
                        </tr>
                      ) : (
                        jiophoneRows.map((obj, index) => {
                          const typeKey =
                            obj?.activationType?.split(" ")[0]?.toUpperCase() ||
                            "";
                          return (
                            <tr key={index}>
                              <td
                                className="text-start"
                                title={activationTypeLabel(obj)}
                              >
                                {activationTypeLabel(obj)}
                              </td>
                              <td className="text-center position-relative">
                                <div className="d-flex align-items-end w-50 justify-content-end">
                                  {obj.activationCount
                                    ? `${obj.activationCount}  `
                                    : "0  "}
                                  {actCsvLoading?.[typeKey] ? (
                                    <div className="p-0 float-right">
                                      <Spinner
                                        showAlert={false}
                                        useStyles={useStyles}
                                      />
                                    </div>
                                  ) : (
                                    <button
                                      type="button"
                                      data-cy={csvName}
                                      className="btn btn-link p-0 float-right"
                                      onClick={() => {
                                        csvHandlerJiophone(obj.activationType);
                                      }}
                                    >
                                      <img
                                        src={
                                          process.env.PUBLIC_URL +
                                          "/assets/images/icons/download-arrow-w.svg"
                                        }
                                        alt="download-arrow"
                                      />
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-none d-sm-block col-12">
        <div className="row">
          {simActivationObj.loading ? (
            <div className="col-md-4">
              <Spinner />
            </div>
          ) : Object.keys(simActivationObj.simActivationData).length ? (
            <CustomSalesCard
              achieved={actualCount}
              target={roundToTwo(targetCount)}
              tileName="Ach/Target"
              csvDownload={isCsvActive === "Y" ? fetchSimActivationCsvData : ""}
              csvName="simAct"
              image="Image4"
              gradient="3"
              loading={actCsvLoading}
              top="5"
              dashboardName={moduleName}
              viewName={section}
            />
          ) : (
            <div className="col-md-4">
              <Error error={simActivationObj.error} />
            </div>
          )}
          {simActivationObj.loading ? (
            <div className="col-md-4">
              <Spinner />
            </div>
          ) : Object.keys(simActivationObj.simActivationData).length ? (
            <CustomSalesCard
              value={roundToTwo(avgPerDayCount)}
              tileName="Avg Per Day (Last 7 days)"
              image="Image5"
              showGraph={true}
              gradient="4"
              top="5"
              dashboardName={moduleName}
              viewName={section}
            />
          ) : (
            <div className="col-md-4">
              <Error error={simActivationObj.error} />
            </div>
          )}
          <div className="col-md-4">
            {simActivationJiophoneObj?.loading ? (
              <Spinner />
            ) : simActivationJiophoneObj?.error ? (
              <Error error={simActivationJiophoneObj.error} />
            ) : (
              <div
                className="grad3 staticHeightSales whiteoverlaycir wow fadeInUp p-1 pt-0"
                style={{ maxHeight: 152, overflowY: "auto" }}
              >
                <table className="table table-sm text-white text-center table-borderless mb-0">
                  <thead>
                    <tr>
                      <th
                        style={{ background: "#fdb082", textAlign: "left" }}
                        scope="col"
                      >
                        <div className="ms-3">Activation Type</div>
                      </th>
                      <th
                        style={{ background: "#fdb082", textAlign: "right" }}
                        scope="col"
                      >
                        <div className="me-3">Activation Count</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {jiophoneRows.length === 0 ? (
                      <tr>
                        <td
                          colSpan={2}
                          className="text-white text-center small py-2"
                          style={{ opacity: 0.9 }}
                        >
                          <div className="ms-2 me-2">
                            No activation type breakdown for this selection.
                          </div>
                        </td>
                      </tr>
                    ) : (
                      jiophoneRows.map((obj, index) => {
                        const typeKey =
                          obj?.activationType?.split(" ")[0]?.toUpperCase() ||
                          "";
                        return (
                          <tr key={index}>
                            <td
                              className="fw-bold text-start"
                              scope="row"
                              title={activationTypeLabel(obj)}
                            >
                              <div className="ms-3">
                                {activationTypeLabel(obj)}
                              </div>
                            </td>
                            <td className="text-center fw-bold">
                              <div
                                className="d-flex align-items-center justify-content-end me-3"
                                style={{ color: "#000" }}
                              >
                                {obj.activationCount ?? "0"}
                                {!actCsvLoading?.[typeKey] ? (
                                  <button
                                    type="button"
                                    data-cy={csvName}
                                    className="btn btn-link p-0 ms-2"
                                    onClick={() =>
                                      csvHandlerJiophone(obj.activationType)
                                    }
                                  >
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/icons/download-arrow-w.svg"
                                      }
                                      alt="Download"
                                    />
                                  </button>
                                ) : (
                                  <Spinner
                                    showAlert={false}
                                    useStyles={useStyles}
                                    width="20px"
                                    className="ms-2"
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SimActivationView;
